import BHCourses from './BHCourses';

export default BHCourses;
